import { render, staticRenderFns } from "./QuizV3.vue?vue&type=template&id=71682f1c&scoped=true"
import script from "./QuizV3.vue?vue&type=script&lang=js"
export * from "./QuizV3.vue?vue&type=script&lang=js"
import style0 from "./QuizV3.vue?vue&type=style&index=0&id=71682f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71682f1c",
  null
  
)

export default component.exports